import { useContext } from "react";
import { LocaleContext } from "../../contexts/locale/locale";
import classes from "./footer.module.css";

export const Footer = () => {
	const { texts } = useContext(LocaleContext);

	const copyright = `© ${texts.general.name} ${new Date().getUTCFullYear()}`;

	return (
		<footer className={classes.footer}>
			<div className={classes.content}>
				<a href="/">
					<img
						className={classes.logo}
						src="/logo.svg"
						alt={texts.general.name}
					/>
				</a>
				<div className={classes.list}>
					<span className={classes.item}>{copyright}</span>
					<a className={classes.item} href="/datenschutz">
						{texts.privacy.hero.title}
					</a>
					<a className={classes.item} href="/impressum">
						{texts.imprint.hero.title}
					</a>
				</div>
			</div>
		</footer>
	);
};
